import { useState, useEffect } from "react";
import { Input, DatePicker, Select, message, Empty, Table } from "antd";
import { ReportService } from "../../../services/reports-services";
import dayjs from "dayjs";
import ApiService from "../../../utils/ApiService";
import useUserStore from "../../../stores/store";
import {
  orderStatusList,
  paymentStatusList,
} from "../../../constant/constants";
import { tableColsOrderList } from "../../../constant/table-cols";
// const filteredOrderStatusList = orderStatusList.filter(
//   (item) => item.value !== 1
// );
// To delete any order the above filter removed
const filteredOrderStatusList = orderStatusList;
const modifiedPaymentStatusList = paymentStatusList.map((item) => ({
  value: item.key,
  label: item.label,
}));

export default function OrderListComponent({
  tableData,
  setSalesFilter,
  handleFilterApply,
  setIsFilterClear,
  loading,
}) {
  console.log('----tableData---', tableData);

  const { user } = useUserStore();
  const [restaurantList, setRestaurantList] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [paymentStatus, setPaymentStatus] = useState("");
  const [restaurantId, setRestaurantId] = useState("");
  const [orderStatus, setOrderStatus] = useState("");

  useEffect(() => {
    setSalesFilter((prev) => ({
      ...prev,
      restaurantId,
      searchText,
      fromDate,
      toDate,
      paymentStatus,
      orderStatus,
      page: 1,
      perPage: 10,
    }));
  }, [restaurantId, searchText, fromDate, toDate, paymentStatus, orderStatus]);

  function onHandleSearchText(e) {
    const val = e.target.value;
    if (ReportService.isTextValid(val)) {
      return;
    }
    setSearchText(val);
  }

  function onHandleFromDate(date, dateString) {
    setFromDate(dateString);
  }

  function onHandleToDate(date, dateString) {
    if (dateString === "") return;
    if (fromDate != "" && !(new Date(dateString) > new Date(fromDate))) {
      message.warning("This date must be grater than from date.");
      return;
    }
    setToDate(dateString);
  }

  function onHandleClearFilter() {
    setIsFilterClear(true);
    setSearchText("");
    setFromDate("");
    setToDate("");
    setPaymentStatus("");
    setOrderStatus("");
    setRestaurantId("");

    setSalesFilter((prev) => ({
      page: 1,
      perPage: 10,
    }));
  }

  const onTableChange = (pagination, filters, sorter) => {
    console.log("---onTableChange--- called--", {
      pagination,
      filters,
      sorter,
    });

    let pageNo = pagination.current;

    if (pagination.pageSize !== tableData.pagination.pageSize) {
      pageNo = 1;
    }
    

    setSalesFilter((prev) => ({
      ...prev,
      page: pageNo,
      perPage: pagination.pageSize,
    }));

    handleFilterApply(pageNo, pagination.pageSize);
  };

  const getRestaurantBranchList = async () => {
    const queryParams = {
      restaurantId: "",
      searchKey: "",
      status: "",
      page: 1,
      perPage: 999999,
    };

    const res = await ApiService.GET_RESTAURANT_BRANCHES(
      queryParams,
      user.token.token
    );

    if (res.status === "ok") {
      const data = res.payload.records;

      const items = data.map((item) => ({
        value: item.id,
        label: `${item.name} (${item.branch})`,
      }));

      setRestaurantList(items);
    }
  };

  useEffect(() => {
    getRestaurantBranchList();
  }, []);

  return (
    <section>
      {/* filters */}
      <div className="flex items-center space-between w-full mt-[20px] mb-[31px]">
        <div className="flex items-center space-x-[15px] items-center w-full">
          {/* start restaurant dropdown */}
          <div className="h-[40px] w-[25%] content-center">
            <Select
              className="w-full h-full"
              onChange={setRestaurantId}
              showSearch
              placeholder="Restaurant"
              filterOption={(input, option) =>
                (option?.label ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              options={restaurantList}
              allowClear // This is enabled to allow clearing the selection
              value={restaurantId || null}
            />
          </div>
          {/* end restaurant dropdown */}

          <div className="h-[40px] w-[10%]">
            <Select
              className="w-full h-full"
              showSearch={false}
              placeholder="Payment"
              optionFilterProp="label"
              onChange={setPaymentStatus}
              options={modifiedPaymentStatusList}
              value={paymentStatus || null}
            />
          </div>

          <div className="h-[40px] w-[10%]">
            <Select
              className="w-full h-full"
              showSearch={false}
              placeholder="Order Status"
              optionFilterProp="label"
              onChange={setOrderStatus}
              options={filteredOrderStatusList}
              value={orderStatus || null}
            />
          </div>
          <div className="h-[40px] w-[10%]">
            <DatePicker
              className={"h-full w-full"}
              onChange={onHandleFromDate}
              placeholder="From Date"
              value={fromDate ? dayjs(fromDate) : null}
              maxDate={toDate ? dayjs(toDate) : null}
            />
          </div>
          <div className="h-[40px] w-[10%]">
            <DatePicker
              className={"h-full w-full"}
              onChange={onHandleToDate}
              placeholder="To Date"
              value={toDate ? dayjs(toDate) : null}
              minDate={fromDate ? dayjs(fromDate) : null}
            />
          </div>
          <div className="h-[40px] w-[20%]">
            <Input
              className="h-full w-full"
              value={searchText || ""}
              onChange={onHandleSearchText}
              placeholder="Order No, Phone"
            />
          </div>
        </div>
        <div className="flex items-center space-x-[20px] h-[40px] w-[200px]">
          <button
            className="w-full h-full bg-black text-[14px] font-bold leading-[16px] text-white rounded-[5px] w-[50%]"
            onClick={onHandleClearFilter}
          >
            Clear
          </button>
          <button
            className="w-full h-full bg-[#FCBD10] text-[14px] font-bold leading-[16px] text-black rounded-[5px] w-[50%]"
            onClick={() => handleFilterApply()}
          >
            Apply
          </button>
        </div>
      </div>

      {/* sales report table */}

      <section className="w-full mb-[44px]">
        {tableData.records.length == 0 ? (
          <div className="h-[50vh] flex items-center justify-center">
            <Empty />
          </div>
        ) : (
          <Table
            className=""
            columns={tableColsOrderList}
            dataSource={tableData.records}
            loading={loading}
            pagination={tableData.pagination}
            onChange={onTableChange}
          />
        )}
      </section>
    </section>
  );
}
